import {
  enforceDescriptions,
  EventData,
} from 'features/cantileverAISystem/components/enforceDescriptions'
import { AIResponseEventName } from 'features/cantileverAISystem/eventName'
import z from 'zod'

export type AIResponseEvent = z.infer<typeof AIResponseEventSchema>

export const AIResponseEventSchema = z.object({
  eventName: z.enum(AIResponseEventName),
  sessionId: z.string().optional().meta({ description: 'Always undefined.' }),
  thoughts: z
    .array(z.string())
    .optional()
    .meta({ description: 'Always undefined.' }),
  function_responses: z
    .any()
    .optional()
    .meta({ description: 'Always undefined.' }),
})

export const makeAIResponseEventDef = <
  TEventName extends AIResponseEventName,
  TEventDataSchema extends EventData,
>({
  eventName,
  eventDataSchemaWithDescriptions,
}: {
  eventName: TEventName
  eventDataSchemaWithDescriptions: TEventDataSchema
}) => {
  enforceDescriptions(eventName, eventDataSchemaWithDescriptions)

  return {
    eventName,
    eventSchema: AIResponseEventSchema.extend({
      eventName: z.literal(eventName),
      data: eventDataSchemaWithDescriptions,
    }),
  }
}
